import { useBackButton } from '@/shared/hooks/useBackButton'
import { useHideNav } from '@/shared/hooks/useHideNav'
import v from '../../../version.json'
import { useStyles } from './styles'
import WebApp from '@twa-dev/sdk'
import { GamedBtn } from '@/shared/ui/gamedBtn'
import { useEffect, useState } from 'react'

import { getStoriesInfoFx } from '@/entities/stories/model/effects'
import { useUnit } from 'effector-react'
import { $gamedId, $userToken } from '@/entities/user'
import { $steamUserData } from '@/entities/platforms/steam/store'
import { $storiesInfo } from '@/entities/stories/model/store'
import { goToStarterPackClaim } from '@/app/routing/events'

export const TestPageView = () => {
  useBackButton({})
  useHideNav(true)

  const userToken = useUnit($userToken)
  const userData = useUnit($steamUserData)
  const gamedId = useUnit($gamedId)

  const storiesInfo = useUnit($storiesInfo)

  useEffect(() => {
    if (!userToken) return
    getStoriesInfoFx(userToken)
  }, [userToken])

  const [isHover, setHover] = useState(false)
  const { classes } = useStyles({})
  const contributor = v.version?.split('::')[0]
  const version = v.version?.split('::')[1]

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`${contributor} ${version}`)
      if (WebApp.platform === 'ios' || WebApp.platform === 'android') {
        for (let i = 0; i < 3; i++) {
          setTimeout(() => {
            WebApp.HapticFeedback.impactOccurred('rigid')
          }, 90 * i)
        }
      }
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }
  if (!storiesInfo || !userData || !gamedId) return null

  return (
    <>
      <div className={classes.root}>
        <button onClick={() => goToStarterPackClaim()}>Go to claim</button>
        {isHover && (
          <span className={classes.version}>
            <p>{contributor}</p>
            <p>{version}</p>
          </span>
        )}
        <GamedBtn
          onClick={handleCopy}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          onTouchStart={() => setHover(true)}
          onTouchEnd={() => setHover(false)}
          icon={isHover ? 'copy' : 'git'}
          iconInvertColor={!isHover}
          iconStyles={{ width: '24px', height: '24px' }}
          variant="floating"
        />
      </div>
    </>
  )
}
